import { render, staticRenderFns } from "./DeletedTemplates.vue?vue&type=template&id=1c4aeca6&"
import script from "./DeletedTemplates.vue?vue&type=script&lang=js&"
export * from "./DeletedTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports